import { render, staticRenderFns } from "./report_issue.vue?vue&type=template&id=52767aaa"
import script from "./report_issue.vue?vue&type=script&lang=js"
export * from "./report_issue.vue?vue&type=script&lang=js"
import style0 from "./report_issue.vue?vue&type=style&index=0&id=52767aaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports